import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ImportacaoXML, tipoImportacaoXml } from '@/pages/importacao-xml';
import { validateRoute } from '@/router/util';

const ParamsSchema = z.object({
    tipo: z.enum(tipoImportacaoXml),
});

// biome-ignore assist/source/useSortedKeys: type inference
export const Route = createFileRoute('/a/importacao/xml/$tipo')({
    params: {
        parse: (params) => {
            const result = ParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
    beforeLoad() {
        validateRoute({
            fintech: true,
        });
    },
    component: Component,
});

function Component() {
    const { tipo } = Route.useParams();

    return <ImportacaoXML tipo={tipo} />;
}
